module.exports = __webpack_public_path__ + "img/miso_mayo.892fff08.jpg";